;(function ($) {
  $(function () {
    const getCookieValue = name =>
      document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() ||
      ''

    function waitForItem (selector, timeout = 5000) {
      return new Promise((resolve, reject) => {
        const observer = new MutationObserver(mutations => {
          mutations.forEach(mutation => {
            const element = document.querySelector(selector)
            if (element) {
              observer.disconnect()
              resolve(element)
            }
          })
        })

        observer.observe(document.body, {
          childList: true,
          subtree: true
        })

        const existingElement = document.querySelector(selector)
        if (existingElement) {
          observer.disconnect()
          resolve(existingElement)
        }

        setTimeout(() => {
          observer.disconnect()
          reject(new Error(`Element ${selector} not found within ${timeout}ms`))
        }, timeout)
      })
    }

    if (Cookies.get('DONEGDPRAlertBoxClosed') != undefined) {
      $('body').addClass('alert-box--is-closed')
    }

    waitForItem('.done-gdpr-toggle-display')
      .then(element => {
        $(element).on('click', function () {
          $('.done-gdpr-alert-box-wrapper').hide()
        })
      })
      .catch(error => {
        console.error(error)
      })

    $(document).on('click', '.done-gdpr-close-link', function () {
      if (getCookieValue('DONEGDPRAlertBoxClosed') != '') {
        $('.done-gdpr-alert-box-wrapper').hide()
        $('body').removeClass('alert-box--is-closed')
      } else {
        $('.done-gdpr-alert-box-wrapper').show()
      }
    })

    $('.js-open-cookie').on('click', function (e) {
      e.preventDefault()
      $('.done-gdpr-alert-box-wrapper').hide()
      $('body').removeClass('alert-box--is-closed')
    })
  })
})(jQuery)
